import { Box, Typography, IconButton, Button } from "@mui/material";
import LinkRouter from "components/navigation/LinkRouter";
import { Check, Circle, X } from "lucide-react";
import { OnboardingTask } from "./OnboardingTypes";
import { useState } from "react";
import useIsMobile from "components/hooks/useIsMobile";

export const Task = ({ task }: { task: OnboardingTask }) => {
  const [isHovered, setIsHovered] = useState(false);
  const isMobile = useIsMobile();

  // Don't show dismissed tasks
  if (task.dismissed) {
    return null;
  }

  const showDismiss =
    !task.completed &&
    task.dismissible &&
    task.onDismiss &&
    (isHovered || isMobile);

  const handleClick = () => {
    if (task.onClick) {
      task.onClick();
    }
  };

  return (
    <Box
      key={task.label}
      sx={{
        display: "flex",
        alignItems: "start",
        gap: "8px",
        justifyContent: "space-between",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "start",
          gap: "8px",
          flex: 1,
        }}
      >
        {task.completed ? (
          <Box
            sx={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              background: "#198282",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Check size={16} color="white" strokeWidth={2.5} />
          </Box>
        ) : (
          <Circle
            size={24}
            stroke="#bdbdbd"
            fill="none"
            style={{ flexShrink: 0 }}
          />
        )}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {(task.completed || !task.url) && (
            <Typography
              variant="bodyHeavy"
              sx={{ display: "inline", lineHeight: "24px" }}
            >
              {task.label}
            </Typography>
          )}

          {!task.completed &&
            task.url &&
            (task.onClick ? (
              <Button
                variant="inline"
                onClick={handleClick}
                sx={{
                  padding: 0,
                  verticalAlign: "middle",
                }}
              >
                {task.label}
              </Button>
            ) : (
              <LinkRouter
                to={task.url}
                targetNew={task.openNewTab}
                style={{ display: "inline", textDecoration: "none" }}
                sx={{ padding: 0 }}
              >
                <Typography variant="bodyHeavy" color="primary">
                  {task.label}
                </Typography>
              </LinkRouter>
            ))}

          {showDismiss && !isMobile && (
            <Typography
              component="span"
              onClick={task.onDismiss}
              variant="body"
              color="text.secondary"
              sx={{
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              dismiss
            </Typography>
          )}
        </Box>
      </Box>

      {/* Mobile X button */}
      {showDismiss && isMobile && (
        <IconButton
          onClick={task.onDismiss}
          sx={{
            padding: "4px",
            color: "#8E9598",
            flexShrink: 0,
          }}
        >
          <X size={20} />
        </IconButton>
      )}
    </Box>
  );
};
